import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const deleteUser = (state,user_id,status) => {
  
  return axios.delete(API + "company/client-delete/"+state+"/?status="+status+"&&user="+user_id ,{headers: authHeader(),});
};
const DeleteCompanyUserService = {
    deleteUser,
  };
  export default DeleteCompanyUserService;